import { IAnimationElementProps } from '../../../common/Animation';

export const layoutAnimationConfig: IAnimationElementProps = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};
